import React from 'react';
import './App.css';
import Header from './Components/Header/Header';
import Home from './Components/Home/Home';
import Footer from './Components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      
      <main style={{ flex: 1 }}>
        <Home />
      </main>
      
      <Footer />
    </div>
  );
}

export default App;
